import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import { AuthProvider } from './components/Auth';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ColorModeProvider } from './components/ColorModeProvider';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ColorModeProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ColorModeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
